import api from "./apiHelper";

export const getSolutionsByAdviseeId = (adviseeId) => {
  return api.get(`/ai-solutions?adviseeId=${adviseeId}`);
};

export const getSolutionById = (solutionId) => {
  return api.get(`/ai-solutions/${solutionId}`);
};

export const createSolution = (payload) => {
  return api.post(`/ai-solutions`, payload);
};

export const updateSolution = (solutionId, payload) => {
  return api.patch(`/ai-solutions/${solutionId}`, payload);
};

export const deleteSolution = (solutionId) => {
  return api.delete(`/ai-solutions/${solutionId}`);
};

export const convertToSolution = (solutionId) => {
  return api.post(`/ai-solutions/convert-to-proposal`, {
    solutionId,
  });
};
